<template>
  <div id="wrapper">
    <!-- Navigation -->
    <app-nav></app-nav>
    <router-view></router-view>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import AppNav from '../components/AppNav';

export default {
   components:{
       'app-nav' : AppNav
   }
}
 
</script>



// WEBPACK FOOTER //
// src/components/Dash.vue